(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["verik-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const isModelCode = (query) => /^[a-z]{4}$/i.test(query);

    document.addEventListener('formdata', (event) => {
      const form = event.target;
      if (!form.matches('[data-verik-search-form]')) return;

      const query = String(event.formData.get('q') || '').trim();
      if (isModelCode(query)) event.formData.set('q', `"${query}"`);
    }, true);

    const normalizeSearch = () => {
      if (!document.querySelector('[data-verik-search-results]')) return;

      const url = new URL(window.location.href);
      const query = (url.searchParams.get('q') || '').trim();
      if (!isModelCode(query)) return;

      url.searchParams.set('q', `"${query}"`);
      url.searchParams.delete('page');
      window.location.replace(url.href);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', normalizeSearch, { once: true });
    } else {
      normalizeSearch();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
